import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface price {
    glass_id?: string,
    glass_work_id?: string,
    price: string,
}

export interface select {
    value: string | number,
    label: string
}

export interface glassWork {
    id: number,
    name: string,
    code: string
}

export interface glass {
    id: number,
    name: string,
    code: string
}

// Add material state
export interface addPriceState {
    services: glassWork[],
    materials: glass[],
    prices: price[],
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialAddPriceState: addPriceState = {
    prices: [{price:'0'}],
    services: [],
    materials: [],
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const addPriceSlice = createSlice({
    name: 'add_price',
    initialState: initialAddPriceState,
    reducers: {
        init: state => initialAddPriceState,
        set: (state, { payload }: PayloadAction<[price]>) => {
            state.prices = [...state.prices, ...payload]
        },
        setPriceValue: (state, { payload }: PayloadAction<{ index: number, value: string }>) => {
            state.prices[payload.index].price = payload.value;
        },
        setService: (state, { payload }: PayloadAction<{ index: number, value: string }>) => {
            state.prices[payload.index].glass_work_id = payload.value;
        },
        setMaterial: (state, { payload }: PayloadAction<{ index: number, value: string }>) => {
            state.prices[payload.index].glass_id = payload.value;
        },
        deletePrice: (state, { payload }: PayloadAction<number>) => {
            state.prices.splice(payload, 1)
        },
        setEditId: (state, { payload }: PayloadAction<number>) => {
            state.editId = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
        addServices: (state, { payload }: PayloadAction<glassWork[]>) => {
            state.services = payload
        },
        addMaterials: (state, { payload }: PayloadAction<glass[]>) => {
            state.materials = payload
        },
    }
})